





































// Importing components
import LayoutApp from '@/layputs/LayoutApp.vue';
import BaseCard from '@/ui/BaseCard.vue';
import BasePagination from '@/base/BasePagination.vue';
import TheTableDeliveryOrders from '@/components/orders/TheTableDeliveryOrders.vue';
import BaseButton from '@/ui/BaseButton.vue';
import BaseInputField from '@/ui/BaseInputField.vue';
// Importing function
import {getDeliveryOrders} from '@/ts/deliveries/get-delivery-orders';

export default {
    name: 'PageDeliveryOrders',
    components: {
        LayoutApp,
        BaseCard,
        BasePagination,
        TheTableDeliveryOrders,
        BaseButton,
        BaseInputField,
    },
    props: {},
    data() {
        return {
            items: [],
            search_param: '',
            status: {},
            channel: {},
        };
    },
    methods: {
        // Switching between pages
        switchPage(page) {
            this.$store.dispatch('setLoadingOn');
            this.$store.dispatch('setCurrentPage', page);
            getDeliveryOrders().finally(() => {
                this.$store.dispatch('setLoadingOff');
            });
        },
    },
    created() {
        // Initializing the items object
        this.items = [{
            text: 'Поръчки',
        }];
        this.$store.dispatch('setQueryParam', '');
        this.$store.dispatch('setOrderParam', '');
        this.$store.dispatch('setSortParam', '');
        this.$store.dispatch('setCurrentPage', 1);
        // Fetching data from the API
        getDeliveryOrders().finally(() => {
            this.$store.dispatch('setLoadingOff');
        });
    },
};
